import { memo, useRef, useState } from 'react'
import { useLoading } from './Loading'
import { Button, Input, Message, Modal } from '@arco-design/web-react'
import { loginBySmsVerifyCode, sendSmsVerifyCode } from '../utils/userApi'
import { IconPhone, IconUnlock } from '@arco-design/web-react/icon'
import SmsButton from './SmsButton'
import ZWContract from './ZWContract'

const SmsLoginModal = memo(
  ({ handleLoginResult, isPhoneLogin, setPhoneLogin }) => {
    const { setLoading } = useLoading()
    const phoneRef = useRef(null)
    const smsRef = useRef(null)

    async function onTryLoginBySms (e) {
      const smsCode = smsRef.current.dom.value
      const phone = phoneRef.current.dom.value
      if (!/[0-9]/.test(smsCode)) {
        e.preventDefault()
        Message.error('验证码格式错误')
        return
      }
      setLoading(true)
      const r = await loginBySmsVerifyCode(phone, smsCode)
      setLoading(false)
      handleLoginResult(r)
    }

    const [isAgree, setAgree] = useState(true)

    return <Modal title="手机验证码登录"
                  visible={isPhoneLogin}
                  maskClosable={false}
                  footer={null}
                  onCancel={e => setPhoneLogin(false)}
    >

      <div className="p-1 mb-2">

        <div className="flex">
          <Input ref={phoneRef}
                 id="phone"
                 className="item" placeholder="请输入11位手机号码"
                 prefix={<IconPhone/>}
                 style={{
                   margin: 5,
                   height: 40,
                   width: 275,
                 }}
          />

          <SmsButton
            onClick={async e => {
              setLoading(true)
              const r = await sendSmsVerifyCode(phoneRef.current.dom.value)
              setLoading(false)
              if (r.code !== 0) {
                Modal.error({
                  title: '获取验证码失败',
                  content: r.msg,
                })
              }
            }}
            style={{
              margin: 5,
              height: 40,
            }}>获取验证码</SmsButton>
        </div>
        <div>
          <Input ref={smsRef}
                 length={5}
                 className="item" placeholder="请输入5位验证码"
                 prefix={<IconUnlock/>}
                 style={{
                   margin: 5,
                   height: 40,
                   maxWidth: 275,
                 }}
          />
          <Button disabled={!isAgree}
                  type="primary"
                  onClick={onTryLoginBySms}
                  style={{
                    margin: 5,
                    height: 40,
                    width: '100%',
                  }}>登录</Button>
        </div>
      </div>
      <ZWContract setAgree={setAgree}/>
    </Modal>
  })

export default SmsLoginModal